"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.productAPISearch.name': '产品搜索和分类',
    'tools.productAPISearch.description': '使用SmartShop API集成搜索产品和获取产品分类',
};
